import { liftV1 } from './v1';
import { liftV2 } from './v2';

/** Versiones del test de Lift. `current` es la que se usa para nuevas altas. */
export const lift = {
  versions: { v1: liftV1, v2: liftV2 },
  current: liftV2,
};
